/**
 * Turns a wire token into something a reader can read: `STATUS_CHANGE` -> `Status change`.
 *
 * The tokens a taxonomy publishes are the values sent upstream, so they are stored and filtered
 * verbatim and only made readable at the point of display. Shared by the condition picker and the
 * table so a value cannot read one way in a filter and another way in the column it filters.
 */
export function humanizeToken(token: string): string {
	const spaced = token.replace(/_/g, ' ').toLowerCase();
	return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
